import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { GuidelineDocumentDialogComponent } from './guideline-document-dialog/guideline-document-dialog.component';

@NgModule({
  declarations: [ErrorDialogComponent, GuidelineDocumentDialogComponent],
  imports: [CommonModule, MatDialogModule, TranslateModule, MatButtonModule, MatIconModule, FormsModule],
})
export class DialogModule {}
